/**
 * Pictures for "Where to retire", drawn in code like the other questionnaires'. Colours come from --vs-* when set.
 */
import { shortMoney } from './stayorgo';
const INK = 'var(--vs-ink,#1b2b28)';
const MUTED = 'var(--vs-muted,#6b7a76)';
const HOME = 'var(--vs-stay,#2f8f9d)';
const AWAY = 'var(--vs-go,#f37f20)';
const esc = s => String(s).replace(/[&<>"]/g, c => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
})[c]);

/**
 * What the same income lives like in each place, as bars in the home currency. places: [{name, home, livesLike, times}]
 */
export function livesBars(_ref) {
  let {
    places,
    currency
  } = _ref;
  const W = 340,
    rowH = 32,
    L = 104,
    R = 86,
    T = 4;
  const max = Math.max(...places.map(p => p.livesLike));
  const H = T + places.length * rowH;
  let svg = `<svg class="VRetire-bars" viewBox="0 0 ${W} ${H}" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${esc(places.map(p => p.name + ': lives like ' + shortMoney(p.livesLike, currency)).join('. '))}">`;
  places.forEach((p, i) => {
    const y = T + i * rowH;
    const w = Math.max(3, (W - L - R) * p.livesLike / max);
    svg += `<text x="${L - 8}" y="${y + 18}" text-anchor="end" font-size="11.5" font-weight="${p.home ? 700 : 400}" fill="${INK}">${esc(p.name)}</text>`;
    svg += `<rect x="${L}" y="${y + 5}" width="${w.toFixed(1)}" height="20" rx="4" fill="${p.home ? HOME : AWAY}"/>`;
    svg += `<text x="${(L + w + 6).toFixed(1)}" y="${y + 19}" font-size="11" font-weight="700" fill="${INK}">${esc(shortMoney(p.livesLike, currency))}${!p.home && p.times && p.times !== 1 ? `<tspan font-weight="400" fill="${MUTED}"> ${p.times}×</tspan>` : ''}</text>`;
  });
  return svg + '</svg>';
}
const inPlace = p => p.code === 'BOTH' ? 'between both' : 'in ' + p.name.replace(/^The /, 'the ');

/** "CA$64,900 a year in retirement lives like CA$239,000 in Nigeria." (or, when home is cheapest, the next best) */
export function headline(s, money) {
  const sorted = s.places.slice().sort((a, b) => b.livesLike - a.livesLike);
  const best = sorted[0];
  if (best.home) {
    const next = sorted[1];
    return money(s.income) + ' a year goes furthest where you live now' + (next ? '; ' + inPlace(next) + ' it lives like ' + money(next.livesLike) + '.' : '.');
  }
  const ng = s.places.find(p => p.code === 'NG');
  return money(s.income) + ' a year in retirement lives like ' + money(best.livesLike) + ' ' + inPlace(best) + (ng && !ng.home && ng !== best ? ', and ' + money(ng.livesLike) + ' in Nigeria' : '') + '.';
}
flarum.reg.add('voucha-assessments', 'common/retire', { livesBars: livesBars,headline: headline, });